import { render } from "./form-branch.vue?vue&type=template&id=c7ab0a42&ts=true"
import script from "./form-branch.vue?vue&type=script&lang=ts"
export * from "./form-branch.vue?vue&type=script&lang=ts"

import "./form-branch.vue?vue&type=style&index=0&id=c7ab0a42&lang=scss"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__